module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-recalculate-8383be4939dc7a75a0eacf35f6a9df40.svg";